import React from 'react';
import PropTypes from 'prop-types';
import { SimpleFlexbox } from 'ctm-components';
import SimpleRadioButton from './simple_radio_button';

/**
 * Simple radio button group component that renders passed options
 * A simple version of the radio button group component without all the everest tied in crap
 * @param {Object} props -  RadioButtonGroup element props
 * @param {Array} props.options -  Array of option values to be built into elements
 * @param {String} value - the radio button current value
 * @param {Function} onChange - the function fired when the user changes the value of the radio button
 * @param {string} identifier - the id
 * @returns {Node} Returns the SimpleRadioButtonGroup
 */
const SimpleRadioButtonGroup = (props) => {
    const { options = [], identifier, value, onChange } = props;
    return (
        <SimpleFlexbox display="flex" column>
            {
                options.map((option) => (
                    <SimpleRadioButton
                        {...option}
                        identifier={identifier}
                        onChange={onChange}
                        key={`${identifier}.${option.value}`}
                        checked={value === option.value}
                    />
                )
                )
            }
        </SimpleFlexbox>
    );
};

SimpleRadioButtonGroup.propTypes = {
    options: PropTypes.array.isRequired,
    identifier: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func
};

export { SimpleRadioButtonGroup };
